import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";

export function getFaqsAccounting(tenant: Tenant): Faq[] {
	return [
		{
			question:
				"Dlouhé roky používáme účetní systém a neumíme si představit, že s ním ze dne na den skončíme. Dokážete nám přechod usnadnit?",
			answer:
				"Ano, pro klienty běžně řešíme přechod ze zastaralých systémů na nové, digitální a plně automatizované řešení. Není se čeho obávat, protože vás celým procesem postupně provedeme a vás i vaše zaměstnance důkladně zaškolíme.",
		},
		{
			question: "Jak dlouho vývoj účetního softwaru na míru trvá?",
			answer:
				"Délka vývoje závisí na rozsahu projektu. Menší řešení obvykle zvládneme za 2 měsíce, větší systémy mohou trvat půl roku až rok.",
		},
		{
			question: "Dokážete účetnictví a fakturaci nastavit tak, abychom nepotřebovali žádné papíry?",
			answer:
				"Ano, rádi pro vás zajistíme zcela bezpapírové účetnictví. Vašim zákazníkům nebo dodavatelům mohou v online podobě chodit například faktury i účtenky.",
		},
		{
			question: "V čem se účetní systém na míru liší od krabicových řešení dostupných na trhu?",
			answer:
				"Rozdíl je v tom, že software na 100% přizpůsobíme vašim potřebám. Budou v něm jen ty funkce, které potřebujete a dle vašich přání připravíme i uživatelské prostředí. V průběhu času systém samozřejmě můžeme rozšiřovat.",
		},
		{
			question: "Když účetnictví funguje kompletně online, jak řešíte zabezpečení?",
			answer: `Bezpečnost klientů je pro nás na prvním místě, proto software vyvíjíme na [${getCloudSolutionsPath(tenant)}][[cloudu]], který se pyšní vysokým kybernetickým zabezpečením (moderní cloudové platformy nabízí šifrování, vícefaktorovou autentizaci a další bezpečnostní opatření).`,
		},
	];
}
